import {
  getLLMBaseTemplateEndpoints,
  getLLMChannelTemplateEndpoints,
  staticLLMTemplateEndpoints,
  IGetChannelLLMTemplateDTO,
  IGetChannelLLMTemplateResponse,
  IUpdateChannelLLMTemplateDTO,
  IUpdateChannelLLMTemplateResponse,
  IResetChannelLLMTemplateDTO,
  IResetChannelLLMTemplateResponse,
  IGetLLMTemplateVariablesResponse,
  IGetBaseLLMTemplatesResponse,
  IGetBaseLLMTemplateDTO,
  IGetBaseLLMTemplateResponse,
  IUpdateBaseLLMTemplateDTO,
  IUpdateBaseLLMTemplateResponse,
} from '@/models/llmTemplate.model';
import { httpClient, ApiResponse } from '@/utils';

class LLMTemplateAPI {
  static getChannelTemplate({ channelId }: IGetChannelLLMTemplateDTO): ApiResponse<IGetChannelLLMTemplateResponse> {
    const { CHANNEL_TEMPLATE } = getLLMChannelTemplateEndpoints({ channelId });
    return httpClient.get<IGetChannelLLMTemplateResponse>(CHANNEL_TEMPLATE);
  }

  static updateChannelTemplate({
    channelId,
    ...data
  }: IUpdateChannelLLMTemplateDTO): ApiResponse<IUpdateChannelLLMTemplateResponse> {
    const { CHANNEL_TEMPLATE } = getLLMChannelTemplateEndpoints({ channelId });
    return httpClient.patch<IUpdateChannelLLMTemplateResponse>(CHANNEL_TEMPLATE, data);
  }

  static resetChannelTemplate({
    channelId,
  }: IResetChannelLLMTemplateDTO): ApiResponse<IResetChannelLLMTemplateResponse> {
    const { CHANNEL_TEMPLATE } = getLLMChannelTemplateEndpoints({ channelId });
    return httpClient.delete<IResetChannelLLMTemplateResponse>(CHANNEL_TEMPLATE);
  }

  static getTemplateVariables(): ApiResponse<IGetLLMTemplateVariablesResponse> {
    return httpClient.get<IGetLLMTemplateVariablesResponse>(staticLLMTemplateEndpoints.GET_VARIABLES);
  }

  static getBaseTemplates(): ApiResponse<IGetBaseLLMTemplatesResponse> {
    return httpClient.get<IGetBaseLLMTemplatesResponse>(staticLLMTemplateEndpoints.GET_BASE_TEMPLATES);
  }

  static getBaseTemplate({ channelType }: IGetBaseLLMTemplateDTO): ApiResponse<IGetBaseLLMTemplateResponse> {
    const { BASE_TEMPLATE } = getLLMBaseTemplateEndpoints({ channelType });
    return httpClient.get<IGetBaseLLMTemplateResponse>(BASE_TEMPLATE);
  }

  static updateBaseTemplate({
    channelType,
    ...data
  }: IUpdateBaseLLMTemplateDTO): ApiResponse<IUpdateBaseLLMTemplateResponse> {
    const { BASE_TEMPLATE } = getLLMBaseTemplateEndpoints({ channelType });
    return httpClient.patch<IUpdateBaseLLMTemplateResponse>(BASE_TEMPLATE, data);
  }
}

export default LLMTemplateAPI;
